import { render, staticRenderFns } from "./AzureAuthentication.vue?vue&type=template&id=2162e4c8&scoped=true&"
import script from "./AzureAuthentication.vue?vue&type=script&lang=js&"
export * from "./AzureAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./AzureAuthentication.vue?vue&type=style&index=0&id=2162e4c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2162e4c8",
  null
  
)

export default component.exports